import Joi from "joi";
import errorsResolver from "../schemeUtils";
import moment from "moment";



export const purityGroupScheme = Joi.object({
    startDate: Joi.date()
        .required()
        .max('01/01/2100')
        .iso().greater(moment().subtract(1, 'days').valueOf())
        .error(errorsResolver({
            dateFormat: `Некорректная дата начала применения`,
            dateGreater: `Дата начала применения должна быть с сегодняшнего дня`
        })),
    prices: Joi.array().items(Joi.object({
        id: Joi.any(),
        price: Joi.number()
            .max(99999999.99)
            .required()
            .min(0.01)
            .error(errorsResolver({
              numberMax: `Цена должна быть до 10 символов`,
              numberMin: `Цена должна быть больше 0`,
              required: `Цена обязательное поле`,
              number: `Цена обязательное поле`
            }))
        })
    )
});
